type IconGridItemProps = {
  icon: string
  label: string
  href: string
  iconWidth?: number
  iconHeight?: number
}

export const IconGridItem = ({
  icon,
  label,
  href,
  iconWidth,
  iconHeight
}: IconGridItemProps ) => {
  return (
    <a
      href={href}
      className="flex flex-col items-center text-center h-full"
    >
      <div
        className="flex-grow flex items-center justify-center" style={{
          minHeight: `${iconHeight ?? 0}px`
        }}
      >
        <img
          src={icon}
          alt={label ? `${label} icon` : `Brand icon`}
          style={{
            width: `${iconWidth ?? 48}px`,
            height: `${iconHeight ?? 48}px`
          }}
          className="transition-opacity hover:opacity-80"
        />
      </div>
      <span
        className="text-sm underline hover:no-underline mt-2 text-[#0093C9]"
      >
        {label}
      </span>
    </a>
  )
}
